import { ArrowLeft, Gift, RotateCw, Tag } from 'lucide-react'

import { Page } from '../../../../../components/layouts/page'
import { Header } from '../../../_components/Header'
import useCollaboratorRegisterPayment from '../../../_hooks/useCollaboratorSignPlanRecurrence'
import { AlertFunctional } from '../../../../../components/ui/alert/AlertFunctional'
import { Path } from '../../../../../router/paths'
import { Column } from '../../../../../components/layouts/columns'
import { Button } from '../../../../../components/ui/button'

export const CollaboratorRegisterPaymentResume = () => {
  const { token, planId, loading, alerts, setAlerts, formContext, HandleCreateNewAssinatureRecurrence } =
    useCollaboratorRegisterPayment()

  return (
    <Page.Root className="pb-6">
      <Page.Content
        style={{
          maxWidth: '400px', // Largura máxima para telas menores
          width: '100%', // Garante que se adapte bem a telas menores
          margin: '0 auto', // Centraliza o conteúdo
        }}
      >
        <Header>
          <a href={Path.CollabRegisterPayment(token, planId)}>
            <ArrowLeft className="has-text-link" size={30} />
          </a>
        </Header>

        <p className="mt-6 subtitle has-text-centered">
          <b>Resumo Contratação {formContext.name}</b>
        </p>

        <div className="has-text-centered">
          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
            Pagamento via <b>{formContext?.payment}</b>
          </p>

          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
            Dados da Cobrança:{' '}
            <b>
              {'*'.repeat(String(formContext?.numero_cartao).length - 4) + String(formContext?.numero_cartao).slice(-4)}
            </b>
          </p>

          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
            Valor: <b>R$ {formContext?.value}</b>
          </p>

          <p style={{ fontSize: '1rem' }}>
            <RotateCw className="mr-4" /> Cobrança a cada <b>{formContext?.typeExpired} Dias</b>
          </p>

          {Number(formContext?.trialDays) > 0 && (
            <p style={{ fontSize: '1rem' }}>
              <Gift className="mr-4" /> Este plano tem <b>{formContext?.trialDays} Dias Grátis!</b>
            </p>
          )}
          {Object.keys(formContext?.cupomSelected ?? {}).length > 0 && (
            <p style={{ fontSize: '1rem' }} className="has-text-success">
              <Tag className="mr-4" /> Valor de <b> R$ {formContext?.cupomSelected?.value}</b> por
              <b>{formContext?.cupomSelected?.daysExpired}</b> Dias!
            </p>
          )}
        </div>

        <Column.Root>
          <Column.Content>
            <Button.Bt
              className="mt-6 is-fullwidth"
              color="is-primary"
              colorText={'has-text-link'}
              loading={loading}
              action={async () => {
                await HandleCreateNewAssinatureRecurrence()
              }}
            >
              Contratar Agora!
            </Button.Bt>
          </Column.Content>
        </Column.Root>
      </Page.Content>
      <AlertFunctional values={alerts} setValues={setAlerts} />
    </Page.Root>
  )
}
